module.exports = __webpack_public_path__ + "static/img/highered_efmd.2e3a4ba0.png";